import { HttpClient, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpParams, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

// Injectable service
@Injectable()
export class HttpService {

    //Action url
    private actionUrl: string;

    //Constructor with dependency injections
    constructor(private http: HttpClient) {

    }

    // get all List dependening on generic type
    public getAll<T>(requestUrl: string): Observable<T> {
        return this.http.get<T>(requestUrl);
    }

    public getAllSync<T>(requestUrl: string): Observable<T> {
        return this.http.get<T>(requestUrl);
    }

    // get List by Id dependening on generic type
    public getSingle<T>(requestUrl, id: number): Observable<T> {
        return this.http.get<T>(requestUrl + "/" + id);

    }
    // get Object by Id dependening on generic type
    public getSingleObject(requestUrl, id: number): Observable<any> {
        return this.http.get(requestUrl + "/" + id);
    }

    public getByText<T>(requestUrl, id: string): Observable<T> {
        return this.http.get<T>(requestUrl + "/" + id);
    }

    public getByTextSync<T>(requestUrl, id: string): Observable<T> {
        return this.http.get<T>(requestUrl + "/" + id).pipe(map((res) => res));
    }

    // add data object
    public post<T>(requestUrl, item: any): Observable<T> {
        const toBeAdd = JSON.stringify(item);
        return this.http.post<T>(requestUrl, toBeAdd);
    }

    // update data object
    public update<T>(requestUrl, id: number, itemToUpdate: any): Observable<T> {
        return this.http.put<T>(requestUrl + "/" + id, JSON.stringify(itemToUpdate));
    }
    // delete data object
    public delete<T>(requestUrl, id: number): Observable<T> {
        return this.http.delete<T>(requestUrl + "/" + id);
    }
    // delete data object
    public getMultipleParam<T>(requestUrl, objects: any): Observable<T> {
        const paramValue = this.buildQueryParams(objects);
        return this.http.get<T>(requestUrl, { params: paramValue });
    }

    public buildQueryParams(source: Object): HttpParams {
        let target: HttpParams = new HttpParams();
        Object.keys(source).forEach((key: string) => {
            const value: string | number | boolean | Date = source[key];
            if ((typeof value !== 'undefined') && (value !== null)) {
                target = target.append(key, value.toString());
            }
        });
        return target;
    }
}

//Header set class
@Injectable()
export class BaseHttpInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let userDataSTorage: any;
        let loggedUserId: string = "0";
        userDataSTorage = localStorage.getItem('LOGGED_USER_VIDA_PROFILE_TEST');
        if (userDataSTorage != undefined) {
            let userData = JSON.parse(userDataSTorage);
            if (userData != null && userData.userId != null && userData.userId != undefined)
                loggedUserId = userData.userId;
        }
        if (!request.headers.has('Access-Control-Allow-Origin')) {
            request = request.clone({ headers: request.headers.set('Access-Control-Allow-Origin', '*') });
        }
        if (!request.headers.has('Content-Type')) {
            request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
        }

        if (!request.headers.has('Accept')) {
            request = request.clone({ headers: request.headers.set('Accept', 'application/json') });
        }

        if (!request.headers.has('Authorization')) {
            request = request.clone({ headers: request.headers.set('Authorization', 'Bearer ' + localStorage.getItem('access_token')) });
        }

        if (!request.headers.has('x-memberid')) {
            request = request.clone({ headers: request.headers.set('x-memberid', loggedUserId) });
        }
        return next.handle(request);
    }
}
